<template>
	<div class="service-locations-financial-card">
		<SectionContainer>
			<!-- Appointment -->
			<template #left>
				<h4>Default Account Codes</h4>
			</template>
			<template #content>
				<!-- RO Default Advisor -->
				<dl>
					<dd>
						Body Shop
					</dd>
					<dd>
						Quick Lube
					</dd>
					<dd>
						Service
					</dd>
				</dl>
			</template>
		</SectionContainer>
		<!-- Shared Settings Section -->
		<SectionContainer>
			<template #left>
				<h4>Default Inbound Account Codes</h4>
			</template>
			<template #content>
				<!-- Shared Settings -->
				<dl>
					<dd>
						Customer Pay
					</dd>
					<dd>
						Extended Service
					</dd>
					<dd>
						Internal
					</dd>
					<dd>
						Warranty
					</dd>
				</dl>
			</template>
		</SectionContainer>
		<dl>
			<dd>
				Extended Service Control
			</dd>
		</dl>
	</div>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';

export default {
	name: 'ServiceLocationsFinancialCard',
	components: { SectionContainer }
};
</script>

<style lang="scss" scoped>
.service-locations-financial-card {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 12px;

	&__item {
		display: block;
	}

	.section-header {
		display: inline-block;
	}
}
</style>
